import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { FilingRestrictedModalService } from '@services/filing-restricted-modal.service';

@Component({
  selector: 'filing-restricted-modal',
  templateUrl: './filing-restricted-modal.component.html',
  styleUrls: ['./filing-restricted-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilingRestrictedModalComponent {
  public isOpen$: Observable<boolean>;

  constructor(private filingRestrictedModalService: FilingRestrictedModalService) {
    this.isOpen$ = this.filingRestrictedModalService.isOpen$;
  }

  public onOpenChange(isOpen: boolean): void {
    if (!isOpen) {
      this.filingRestrictedModalService.close();
    }
  }
}
